import { render, staticRenderFns } from "./CheckItem.vue?vue&type=template&id=f716274a&scoped=true&"
import script from "./CheckItem.vue?vue&type=script&lang=js&"
export * from "./CheckItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckItem.vue?vue&type=style&index=0&id=f716274a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f716274a",
  null
  
)

export default component.exports